export interface TimezoneResponse {
  TimeZoneId: string
  TimeZoneName: string
}

export class Timezone {
  public timeZoneId?: string
  public timeZoneName?: string

  constructor({ timeZoneId, timeZoneName }: Partial<Timezone>) {
    this.timeZoneId = timeZoneId
    this.timeZoneName = timeZoneName
  }

  public static fromResponse(response?: TimezoneResponse): Timezone {
    return new Timezone({
      timeZoneId: response?.TimeZoneId,
      timeZoneName: response?.TimeZoneName,
    })
  }
}
